// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__1DDwY","load2":"Spinner__load2__1N7mg","LoaderInline":"Spinner__LoaderInline__1NUCP","load7":"Spinner__load7__2S5ij"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 335
// module chunks = 0